export default __webpack_public_path__ + "static/media/footerIcon.5706dda6.png";